import React from "react";
import { Box, Button, CircularProgress, Divider } from "@mui/material";

const MicrosoftAuthButton = ({ disabled, loading, onClick }) => (
  <>
    <Divider sx={{ my: 3, color: "text.secondary", fontSize: 12 }}>or</Divider>

    <Button
      type='button'
      aria-busy={Boolean(loading)}
      variant='outlined'
      fullWidth
      aria-label={
        loading ? "Connecting to Microsoft" : "Continue with Microsoft"
      }
      disabled={disabled || loading}
      onClick={onClick}
      sx={{
        py: 0.75,
        minHeight: 48,
        whiteSpace: "normal",
        fontSize: "0.9375rem",
        fontWeight: 500,
        textTransform: "none",
        borderColor: "#CCE4F7",
        color: "#005A9E",
        backgroundColor: "transparent",
        borderRadius: "8px",
        boxShadow: "none",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: 1,
        "& .MuiButton-startIcon": {
          marginRight: 0,
          marginLeft: 0,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        },
        "&:hover": {
          borderColor: "#9DC8E8",
          backgroundColor: "rgba(0, 90, 158, 0.04)",
          boxShadow: "none",
        },
        "&:active": {
          transform: "scale(0.99)",
        },
        "&:disabled": {
          borderColor: "#E1DFDD",
          color: "#A19F9D",
          backgroundColor: "transparent",
          "& .microsoft-ms-logo": {
            opacity: 0.45,
            filter: "grayscale(0.35)",
          },
        },
      }}
      startIcon={
        <Box
          className='microsoft-ms-logo'
          component='span'
          sx={{
            display: "flex",
            height: 18,
            width: 18,
            mr: 0.25,
            alignItems: "center",
            justifyContent: "center",
            flexShrink: 0,
            opacity: loading ? 0 : 1,
            transition: "opacity 0.15s ease",
          }}
          aria-hidden
        >
          <svg
            viewBox='0 0 24 24'
            width={18}
            height={18}
            style={{ display: "block", verticalAlign: "middle" }}
          >
            <rect fill='#f25022' x='1' y='1' width='10' height='10' />
            <rect fill='#7fba00' x='13' y='1' width='10' height='10' />
            <rect fill='#00a4ef' x='1' y='13' width='10' height='10' />
            <rect fill='#ffb900' x='13' y='13' width='10' height='10' />
          </svg>
        </Box>
      }
    >
      <Box
        sx={{
          position: "relative",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          minHeight: 20,
          width: "100%",
        }}
      >
        {loading && (
          <CircularProgress
            size={20}
            sx={{
              color: "#005A9E",
              position: "absolute",
              left: "50%",
              top: "50%",
              marginTop: "-10px",
              marginLeft: "-10px",
            }}
          />
        )}
        <Box
          component='span'
          sx={{
            visibility: loading ? "hidden" : "visible",
            textAlign: "center",
          }}
        >
          Continue with Microsoft
        </Box>
      </Box>
    </Button>
  </>
);

export default MicrosoftAuthButton;
